module.exports = __webpack_public_path__ + "static/media/leads-icon.df55b07d.svg";